<template>
  <div>
    <div class="mb-8 flex justify-start max-w-3xl">
      <h1 class="font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('shops')">Shops</inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        {{ form.name }}
      </h1>
    </div>
    <trashed-message v-if="shopData.deleted_at" class="mb-6" @restore="restore">
      This shop has been deleted.
    </trashed-message>
    <div class="bg-white rounded shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="submit">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Name" />

          <text-input v-model="form.phone" :error="errors.phone" class="pr-6 pb-8 w-full lg:w-1/2" label="Phone" />

          <select-input v-model="form.city" :error="errors.brand" class="pr-6 pb-8 w-full lg:w-1/2" label="City">
            <option v-for="city in cities" :key="city.id" :value="city.id" :selected="city.id === form.city">{{city.name}}</option>
          </select-input>

          <label class="pr-6 pb-8 w-full lg:w-full" :class="{ 'opacity-25': form.isMain }">
            <input type="checkbox" class="form-checkbox" value="1" v-model="form.hasStock" :disabled="form.isMain">
            <span class="ml-2 text-sm text-gray-600">Gere son stock</span>
          </label>

        </div>
        <div class="px-8 py-4 bg-gray-100 border-t border-gray-200 flex items-center">
          <button v-if="!shopData.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Shop</button>
          <loading-button :loading="sending" class="btn-indigo ml-auto" type="submit">Update Shop</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Layouts/AppLayout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return {
      title: `${this.form.name}`,
    }
  },
  layout: Layout,
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  props: {
    errors: Object,
    shopData: Object,
    operators: Array,
    cities: Array,
  },
  remember: 'form',
  data() {
    return {
      sending: false,
      form: {
        id: this.shopData.id,
        name: this.shopData.name,
        city: this.shopData.city.id,
        phone: this.shopData.phone,
        hasStock: this.shopData.hasStock,
        isMain: this.shopData.isMain,
      },
    }
  },
  methods: {
    submit() {
      var data = new FormData()
      data.append('name', this.form.name || '')
      data.append('city', this.form.city || '')
      data.append('hasStock', this.form.hasStock || '')
      data.append('phone', this.form.phone || '')
      data.append('_method', 'put')

      this.$inertia.post(this.route('shops.update', this.shopData.id), data, {
        onStart: () => this.sending = true,
        onFinish: () => this.sending = false,
        onSuccess: () => {
          if (Object.keys(this.$page.props.errors).length === 0) {

          }
        },
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this Shop?')) {
        this.$inertia.delete(this.route('shops.destroy', this.shopData.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this Shop?')) {
        this.$inertia.put(this.route('shops.restore', this.shopData.id))
      }
    },
  },
}
</script>
